import { string, func } from 'prop-types'
import { renderIcon, kuiperClassNames } from '../../utils'

const Action = ({ icon, handler }) => (
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events
  <div
    role="button"
    tabIndex={0}
    className={kuiperClassNames('remover')}
    onClick={handler}
  >
    {renderIcon(icon, { ariaLabel: 'Remove', ariaMode: 'presentational' })}
  </div>
)

Action.propTypes = {
  handler: func,
  icon: string,
}

export default Action
